/**
 * App component used for providing state to react router
 * then passing state to routing system component
 *
 * Reset styles are also used here
 */

import React, { useEffect } from "react"
import { History } from "history"
import { ConnectedRouter } from "connected-react-router"
import { Routes } from "./Routes"
import "dash-styled/dist/main.css"
import "react-toastify/dist/ReactToastify.css"
import "slick-carousel/slick/slick.css"
import "./App.module.css"
import "resha/build/main.css" // this introduces tailwind's reset CSS
import "ramper/dist/main.css"

import { DashStyled } from "dash-styled"
import { Notification } from "./Components/Views/Notification/Notification"
import { HelmetProvider } from "react-helmet-async"
import { useAppState } from "./Hooks/useReduxState"
import * as Sentry from "@sentry/react"
import { NeqlClientContext } from "./Context/NeqlClientContext"
import { useNeqlClients } from "./Hooks/useNeqlClients"
import { selectUser } from "./Helpers/Functions/Selectors/auth"

interface Props {
    history: History
}

export const App = ({ history }: Props) => {
    const user = useAppState(selectUser)
    const graphqlClients = useNeqlClients()

    useEffect(() => {
        Sentry.setUser(
            user === undefined ? null : { id: user.id, email: user.email }
        )
    }, [user])

    return (
        <NeqlClientContext.Provider value={graphqlClients}>
            <DashStyled>
                <HelmetProvider>
                    <ConnectedRouter history={history}>
                        <Routes />
                    </ConnectedRouter>
                    <Notification />
                </HelmetProvider>
            </DashStyled>
        </NeqlClientContext.Provider>
    )
}
